import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CPMemberService } from 'src/app/cp-member/services/CPMember.service';
@Component({
  selector: 'app-track-claim-details-mobile',
  templateUrl: './track-claim-details-mobile.component.html',
  styleUrls: ['./track-claim-details-mobile.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackClaimDetailsMobileComponent {
  stages: Array<{ key: string; data: any }> = [];
  isLoading = true;
  claimNo;
  uploadedDocsList;
  claimStatus;
  constructor(private cpMemberService: CPMemberService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.paramMap.subscribe(pm => {
      this.claimNo = pm.get('id');
      if (!this.claimNo) {
        this.isLoading = false;
        return;
      }

      this.cpMemberService
        .getClaimsJournery(this.claimNo)
        .then(journey => {
          this.claimStatus = journey.claimStatus
          const keys = Object.keys(journey)
            .filter(k => /^s\d+$/.test(k))
            .sort((a, b) => +a.slice(1) - +b.slice(1));

          this.stages = keys.map(k => ({ key: k, data: journey[k] })).filter(x => !!x.data);

          this.isLoading = false;
        })
        .catch(err => {
          console.error('Error loading journey', err);
          this.isLoading = false;
        });
    });
  }


}
